module.exports = __webpack_public_path__ + "VAGRoundedStd-Light.1b4b6dd6627bd834bc65.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.eot
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.eot
// module chunks = styles